import React from "react";

// Ten of the best-known thought leaders who teach on 42courses, in the order
// the picture shows them, Rory first (Chris's line-up, 29 Oct 2026). The
// picture is drawn from their portraits on the site, cropped to the face and
// set in black and white; rebuild it if the line-up changes.
const NAMES = [
  "Rory Sutherland",
  "Cindy Gallop",
  "Sir John Hegarty",
  "Laurie Santos",
  "Josy Paul",
  "Debbi Vandeven",
  "Trevor Robinson",
  "Vicki Maguire",
  "Meik Wiking",
  "Piyush Pandey",
];

// Across the top of the Pass and Lifetime cards in place of an icon: the
// faces say what the money buys better than a shield or an infinity sign.
const ThoughtLeadersPhoto: React.FC = () => (
  <img
    className="plan-photo"
    src={require("../../../../../../assets/images/checkout/thought-leaders.jpg")}
    alt={`${NAMES.slice(0, -1).join(", ")} and ${NAMES[NAMES.length - 1]}, some of the thought leaders who teach on 42courses`}
    width={800}
    height={318}
  />
);

export default ThoughtLeadersPhoto;
